import '@/index.css';
import 'simplebar-react/dist/simplebar.min.css';

import { Global } from '@emotion/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { ShoplflowProvider } from '@shoplflow/base';

import App from '@/App';
import reset from '@/styles/reset';

import '@shoplflow/base/styles';
import '@shoplflow/base/reset';

// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <ShoplflowProvider domain='SHOPL'>
        <QueryClientProvider client={queryClient}>
          <Global styles={reset} />
          <App />
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        </QueryClientProvider>
      </ShoplflowProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
